module.exports = __webpack_public_path__ + "img/slider-3.68642d20.jpg";